import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Chip,
  Badge,
  Divider,
  FormControl,
  Button,
  Paper,
  Grid,
  TextField,
  Avatar,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { editStyles as styles } from "./styles";
import { priceFormat } from "../../../utils/format";
import LabelForm from "../../../partials/labelForm";
import PriceFormat from "../../../partials/priceFormat";
import {
  caculateTempPrice,
  caculateTotalPrice,
  caculateDiscount,
  caculateVoucher,
  caculateTax,
} from "../../../helper/calculate";

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      booking: {
        _id: "",
        customerCode: "",
        branchName: "",
        branchCode: "",
        countryCode: "",
        customerMobile: "",
        customerName: "",
        serviceCode: "",
        employeeCode: "",
        employeeName: "",
        startTime: "",
        endTime: "",
        item: [],
        status: "",
        quatity: "",
        createdAt: "",
        updatedAt: "",
        spaNote: "",
        customerNote: "",
        employees: [],
      },
    };
  }
  componentDidMount() {
    this.setState({ booking: this.props.booking });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.booking !== nextProps.booking) {
      this.setState({ booking: nextProps.booking });
    }
  }
  handleChange = (event) => {
    let target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    let name = target.name;

    let booking = this.state.booking;
    booking[name] = value;

    this.setState({ booking });
  };
  handleSubmit = () => {
    this.props.handleSubmit(this.state.booking);
  };

  render() {
    const { classes, t } = this.props;
    let booking = this.state.booking;
    booking.item = booking.item || [];
    return (
      <Paper square={true} className={classes.container}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={5}>
            <TextField
              disabled
              // variant="outlined"
              label={t("booking_listbooking_editform_note_of_customer")}
              name="customerNote"
              fullWidth
              multiline
              rows="2"
              rowMax="4"
              margin="normal"
              value={booking.customerNote}
              onChange={this.handleChange}
              className={classes.textField}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              label={t("booking_listbooking_editform_note_of_spa")}
              name="spaNote"
              fullWidth
              multiline
              rows="2"
              rowMax="4"
              margin="normal"
              value={booking.spaNote}
              onChange={this.handleChange}
              className={classes.textField}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={2} sm={2} className={classes.containerButton}>
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={this.handleSubmit}
            >
              {t("booking_listbooking_editform_save")}
            </Button>
          </Grid>
          {booking.reasonSpaCancel && (
            <Grid item xs={12} sm={12}>
              <label className={classes.textField}>
                {t("booking_listbooking_editform_reason_spa_cancel")}
              </label>
              <div>{booking.reasonSpaCancel}</div>
            </Grid>
          )}
          <Grid item xs={12} sm={12}>
            <FormControl fullWidth variant="outlined">
              <LabelForm label={t("booking_listbooking_editform_employee")} />
              <div>
                {booking.employees &&
                  booking.employees.map((staff, index) => {
                    if (staff && staff.name)
                      return (
                        <Chip
                          key={index}
                          avatar={
                            <Avatar
                              className={classes.avatar}
                              src={staff.avatarImage}
                            >
                              {!staff.avatarImage
                                ? staff.nickname
                                  ? staff.nickname.substr(0, 1)
                                  : staff.name
                                  ? staff.name.substr(0, 1)
                                  : ""
                                : ""}
                            </Avatar>
                          }
                          label={staff.name}
                          className={classes.chip}
                        />
                      );
                  })}
              </div>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormControl fullWidth variant="outlined">
              <LabelForm label={t("booking_listbooking_editform_item")} />
              <div>
                {booking.item.length && !booking.item[0].itemCode ? (
                  <div>Not any item assigned</div>
                ) : (
                  booking.item.map((item, index) => {
                    if (item)
                      return (
                        <Badge
                          className={classes.chip}
                          key={index}
                          style={{
                            marginLeft: Number(item.quantity) > 1 ? 14 : 0,
                          }}
                          classes={{ badge: classes.badge }}
                          color="primary"
                          badgeContent={
                            item.quantity === undefined ? "" : item.quantity
                          }
                          invisible={Number(item.quantity) > 1 ? false : true}
                        >
                          <Chip
                            label={
                              <ItemBage
                                name={item.itemName}
                                price={item.price}
                                currencyCode={item.currencyCode}
                                time={item.itemTime}
                                className={{
                                  chipItem: classes.chipItem,
                                  textItem: classes.textItem,
                                }}
                                t={t}
                              />
                            }
                            color="default"
                          />
                        </Badge>
                      );
                  })
                )}
              </div>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth variant="outlined">
              <LabelForm
                label={t("booking_listbooking_editform_estimate_price")}
              />
              <PriceFormat value={caculateTempPrice(booking)} />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth variant="outlined">
              <LabelForm label={t("booking_listbooking_editform_tax")} />
              <PriceFormat value={caculateTax(booking)} />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth variant="outlined">
              <LabelForm
                label={t("booking_listbooking_editform_value_discount")}
              />
              {caculateDiscount(booking) == 0 ? (
                t("no_apply")
              ) : (
                <PriceFormat value={caculateDiscount(booking)} />
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth variant="outlined">
              <LabelForm
                label={t("booking_listbooking_editform_voucher_money")}
              />
              {caculateVoucher(booking) == 0 ? (
                t("no_apply")
              ) : (
                <PriceFormat value={caculateVoucher(booking)} />
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth variant="outlined">
              <LabelForm
                label={t("booking_listbooking_editform_total_price")}
              />
              {booking.totalPrice == 0 ? (
                t("free")
              ) : (
                <PriceFormat value={booking.totalPrice} />
              )}
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}
const ItemBage = ({ name, price, currencyCode, time, t, className }) => {
  return (
    <div className={className.chipItem}>
      <span className={className.textItem}>{name}</span>
      <Divider orientation="vertical" flexItem={true} />
      <span className={className.textItem}>{`${priceFormat(
        price
      )} ${currencyCode}`}</span>
      <Divider orientation="vertical" flexItem={true} />
      <span className={className.textItem}>{`${time} ${t("minutes")}`}</span>
    </div>
  );
};

EditForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  bookingDispatch: dispatch.booking,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(EditForm)));
